import React from 'react';
import { Switch as AntSwitch } from 'antd';

/**
 * Wrapper component for Ant Design Switch
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Switch functionality including checked, disabled, size, and loading options.
 * 
 * @component
 * @example
 * import { Switch } from '../GeneralComponents/ui';
 * 
 * <Switch defaultChecked />
 * <Switch checked={checked} onChange={onChange} />
 * <Switch disabled />
 * <Switch size="small" />
 * <Switch loading />
 * 
 * @see https://ant.design/components/switch/ - Ant Design Switch documentation
 */
const Switch = (props) => {
  return <AntSwitch {...props} />;
};

export default Switch;

